import { AgentEndpoints, RequestMethods, useRequest } from '@src/shared';
import type { CommonResponse } from '@src/shared/types';
import type { RequestDeps } from '@src/shared/types/request.types';

import type {
  ConfirmAgentRequestParams,
  ConfirmAgentResponse,
} from './confirm-agent.types';

export const useConfirmAgent = (
  request: ConfirmAgentRequestParams,
  deps: RequestDeps
) => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    ConfirmAgentRequestParams,
    ConfirmAgentResponse,
    CommonResponse
  >({
    params: {
      key: 'confirmAgent',
      method: RequestMethods.POST,
      url: `${AgentEndpoints.AGENTS}/confirmation`,
      request,
      fetchManual: true,
      deps,
    },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
